export default "__VITE_ASSET__BRFY37ds__"